import React from "react"
import styled from "styled-components"
import { colors, themeOptions } from "../layouts/Styles"
import SendArrowSVG from "../assets/icons/line-arrow.svg"

const buttonSizes = {
  ["small"]: "0.4rem 0.6rem",
  ["medium"]: "0.5rem 1.6rem",
  ["large"]: "0.8rem 2rem",
}

const buttonColors = {
  ["primary"]: colors.primary.main,
  ["secondary"]: colors.background.default,
}

type ButtonTypes = {
  text: string
  variant: "primary" | "secondary"
  size: "small" | "medium" | "large"
  align?: "center" | "right" | "left"
  onClick?: (e?: React.MouseEvent<any, MouseEvent>) => void
  arrow?: boolean
}

const Button: React.FC<ButtonTypes> = ({
  size,
  variant,
  text,
  onClick,
  align,
  arrow = false,
}) => (
  <ButtonContainer {...{ align }}>
    <ButtonContainerInner
      size={buttonSizes[size]}
      bgColor={buttonColors[variant]}
      {...{ onClick }}
    >
      {text}
      {arrow && <SendArrowSVG />}
    </ButtonContainerInner>
  </ButtonContainer>
)

const ButtonContainer = styled.div<{
  align?: "center" | "right" | "left"
}>`
  display: flex;
  ${props => props.align && `justify-content:  ${props.align}`};
`

const ButtonContainerInner = styled.div<{
  size: string
  bgColor: string
  align?: "center" | "right" | "left"
}>`
  background-color: ${props => props.bgColor};
  border-radius: ${themeOptions.radius};
  padding: ${props => props.size};
  color: ${({ theme }) => theme.primary.contrastText};
  border: 1px solid ${props => props.bgColor};

  svg {
    width: 1.4rem;

    polyline,
    line {
      stroke: ${({ theme }) => theme.primary.contrastText} !important;
    }
  }

  ${({ theme, bgColor }) =>
    bgColor === colors.background.default &&
    `
    color: ${theme.text.main};
    border-color: ${theme.text.main};
    svg {
      polyline,
      line {
        stroke: ${theme.text.main} !important;
      }
    }
  `}

  font-weight: 500;
  height: fit-content;
  cursor: pointer;
  position: relative;
  width: fit-content;
  display: flex;
  flex-direction: row;
  gap: 1rem;

  :after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
    border-radius: ${themeOptions.radius};
    transition: ${themeOptions.transition};
    background-color: rgb(0, 0, 0);
    opacity: 0;
    top: 0;
    left: 0;
    opacity: 0;
  }

  &:hover:after {
    opacity: 0.07;
  }
`

export default Button
